import { getImageSizeBucket } from '@gumtree/shared/src/util/image-size-bucket';
import { DeviceTypes } from '@gumtree/shared/src/types/client-data';
import MetricsRegistry from '../metrics-registry';
import { getAppViewDevice } from '../../render/util/app-view-utils';

type UploadStage = 'compression' | 'upload';

interface UploadBasePayload {
    durationMs: number;
    os?: string;
    device?: DeviceTypes;
    appViewDevice: ReturnType<typeof getAppViewDevice>;
    imageType: string;
    resizedImageSizeBytes: number;
    imageSizeBytes: number;
    state: 'success' | 'fail';
}

interface UploadStageDurationPayload extends UploadBasePayload {
    stage: UploadStage;
}

class UploadImageMetrics extends MetricsRegistry {
    private static readonly STAGE_DURATION_EVENT = 'stage_duration_milliseconds';
    private static readonly TOTAL_DURATION_EVENT = 'total_duration_milliseconds';

    registerStageDuration({
        stage,
        durationMs,
        os,
        device,
        appViewDevice,
        imageType,
        imageSizeBytes,
        resizedImageSizeBytes,
        state,
    }: UploadStageDurationPayload) {
        this.registerClientSideHistogramEvent(UploadImageMetrics.STAGE_DURATION_EVENT, durationMs, {
            stage,
            os,
            device,
            appViewDevice,
            imageType,
            resizedImageSizeBucket: getImageSizeBucket(resizedImageSizeBytes),
            sizeBucket: getImageSizeBucket(imageSizeBytes),
            state,
        });
    }

    registerTotalDuration({
        durationMs,
        os,
        device,
        appViewDevice,
        imageType,
        imageSizeBytes,
        resizedImageSizeBytes,
        state,
    }: UploadBasePayload) {
        this.registerClientSideHistogramEvent(UploadImageMetrics.TOTAL_DURATION_EVENT, durationMs, {
            os,
            device,
            appViewDevice,
            imageType,
            resizedImageSizeBucket: getImageSizeBucket(resizedImageSizeBytes),
            sizeBucket: getImageSizeBucket(imageSizeBytes),
            state,
        });
    }

    getModuleName() {
        return 'upload_image';
    }

    getCountersToRegister() {
        return [];
    }

    getHistogramsToRegister() {
        const buckets = require('prom-client').linearBuckets(0, 200, 150);

        return [
            {
                name: UploadImageMetrics.STAGE_DURATION_EVENT,
                labelNames: [
                    'stage',
                    'os',
                    'device',
                    'appViewDevice',
                    'imageType',
                    'resizedImageSizeBucket',
                    'sizeBucket',
                    'state',
                ],
                buckets,
            },
            {
                name: UploadImageMetrics.TOTAL_DURATION_EVENT,
                labelNames: [
                    'os',
                    'device',
                    'appViewDevice',
                    'imageType',
                    'resizedImageSizeBucket',
                    'sizeBucket',
                    'state',
                ],
                buckets,
            },
        ];
    }
}

export default new UploadImageMetrics();
